import { Button, Paper, useMediaQuery, useTheme } from '@material-ui/core'
import { useContext, useEffect, useState } from 'react'
import MainContainer from '../../components/MainContainer'
import MainHeader from '../../components/MainHeader'
import MainHeaderButtonsWrapper from '../../components/MainHeaderButtonsWrapper'

import ConfirmationModal from '../../components/ConfirmationModal'
import QuickMessageDialog from '../../components/QuickMessageDialog'
import QuickTable from '../../components/QuickTable'

import { toast } from 'react-toastify'
import { i18n } from '../../translate/i18n'

import { MessageSquareQuote } from 'lucide-react'
import { AuthContext } from '../../context/Auth/AuthContext'
import useQuickMessages from '../../hooks/useQuickMessages'
import { useStyles } from './style'
import { ButtonAddNew } from '../../components/ButtonAddNew'

function QuickMessages(props) {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const [messages, setMessages] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [messageSelected, setMessageSelected] = useState({})
  const [showOnDeleteDialog, setShowOnDeleteDialog] = useState(false)

  const {
    list: listMessages,
    save: saveMessage,
    update: updateMessage,
    deleteRecord: deleteMessage
  } = useQuickMessages()

  const { user } = useContext(AuthContext)

  const columns = [
    { field: 'shortcode', headerName: 'Atalho' },
    { field: 'message', headerName: 'Mensagem' }
  ]

  useEffect(() => {
    const fetchData = async () => {
      await loadingQuickMessages()
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadingQuickMessages = async () => {
    setLoading(true)
    try {
      const companyId = localStorage.getItem('companyId')
      const messages = await listMessages({ companyId, userId: user.id })
      setMessages(messages)
    } catch (e) {
      toast.error(e)
    }
    setLoading(false)
  }

  const handleOpenToAdd = () => {
    setModalOpen(true)
  }

  const handleOpenToEdit = message => {
    setMessageSelected(message)
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    setMessageSelected({
      id: null,
      message: '',
      shortcode: '',
      visibility: 'all',
      queueIds: []
    })
  }

  const handleSave = async message => {
    try {
      const record = await saveMessage(message)
      await loadingQuickMessages()
      toast.success('Messagem adicionada com sucesso.')
      return record
    } catch (e) {
      toast.error(e)
    }
  }

  const handleEdit = async message => {
    try {
      const record = await updateMessage(message)
      await loadingQuickMessages()
      toast.success('Messagem atualizada com sucesso.')
      return record
    } catch (e) {
      toast.error(e)
    }
  }

  const handleDelete = async message => {
    handleCloseModal()
    try {
      await deleteMessage(message.id)
      await loadingQuickMessages()
      toast.success('Messagem excluída com sucesso.')
    } catch (e) {
      toast.error(e)
    }
  }

  return (
    <>
      <MainContainer>
        <MainHeader
          title={i18n.t('quickMessages.title')}
          description=" Respostas Rápidas são mensagens pré-definidas para agilizar o
                atendimento no WhatsApp."
          showTutorial={!isMobile}
          // onTutorialClick={handleOpenTutorial}
        >
          <MainHeaderButtonsWrapper>
            <ButtonAddNew
              onClick={handleOpenToAdd}
              startIcon={<MessageSquareQuote size={20} />}
              label={i18n.t('quickMessages.buttons.add')}
            />
          </MainHeaderButtonsWrapper>
        </MainHeader>
        <Paper className={classes.mainPaper} variant="outlined">
          <QuickTable
            columns={columns}
            data={messages}
            loading={loading}
            actions={['edit', 'delete']}
            onEdit={handleOpenToEdit}
            onDelete={message => {
              setMessageSelected(message)
              setShowOnDeleteDialog(true)
            }}
          />
        </Paper>
        <QuickMessageDialog
          messageSelected={messageSelected}
          modalOpen={modalOpen}
          onClose={handleCloseModal}
          editMessage={handleEdit}
          saveMessage={handleSave}
        />
        <ConfirmationModal
          title="Excluir Mensagem Rápida"
          open={showOnDeleteDialog}
          onClose={setShowOnDeleteDialog}
          onConfirm={async () => {
            await handleDelete(messageSelected)
          }}
        >
          Ao excluir este registro, a ação é irreversível e todos os dados serão
          permanentemente removidos.
        </ConfirmationModal>
      </MainContainer>
    </>
  )
}

export default QuickMessages
